import React, { useMemo } from "react";
import invitationHero from "../../../shared/resources/image/invitation-header.png";
import invitationScbHero from "../../../shared/resources/image/invitation-scb-header.png";
import { useLocation } from "react-router";
import { Invitation } from "../components/Invitation";
import { InvitationCampaign } from "../components/Invitation/types/campaign";



export const ThtPlusInvitationScreen: React.FC = () => {
  const { search } = useLocation();
  const { channel, token } = useMemo(() => {
    const queryParams = new URLSearchParams(search);
    return {
      channel: queryParams.get('channel'),
      token: queryParams.get('token')
    }
  }, [search])  

  return (
    <Invitation channel={channel} token={token} campaign={InvitationCampaign.THT_PLUS} >
      <Invitation.Banner />
      <Invitation.FormSection />
      <Invitation.TermsSection />
      <Invitation.SuccessSection />
    </Invitation>
   
  );
};